<template>
    <v-menu v-model="menu" :close-on-content-click="false" location="bottom start" :disabled="isDisabled">
        <template v-slot:activator="{ props: activator }">
            <v-text-field
                placeholder="DD/MM/YYYY"
                append-inner-icon="mdi-calendar"
                v-bind="{ ...$attrs, ...activator }"
                :model-value="displayValue"
                readonly
                @click:clear="clearDate"
            ></v-text-field>
        </template>
        <v-date-picker
            :model-value="pickerDate"
            :min="min"
            :max="max"
            hide-header
            show-adjacent-months
            color="primary"
            @update:model-value="onPick"
        ></v-date-picker>
    </v-menu>
</template>

<script>
import moment from 'moment';

/**
 * BsDateField — app-wide date input that ALWAYS displays DD/MM/YYYY regardless of
 * browser locale (native <input type="date"> can't be reformatted). It shows a
 * read-only text field + a calendar popup, and emits the value as 'YYYY-MM-DD'
 * so existing v-model bindings / backend payloads are unchanged.
 *
 * Drop-in replacement for <v-text-field type="date" v-model="x" ...>:
 *   <BsDateField v-model="x" label="..." ... />
 * All extra attrs (label, density, hide-details, error-messages, variant,
 * clearable, rules, disabled, class, ...) pass through to the inner field.
 */
export default {
    name: 'BsDateField',
    inheritAttrs: false,
    props: {
        modelValue: { type: [String, Date], default: null },
        // Optional bounds for the calendar (accept 'YYYY-MM-DD' or Date)
        min: { type: [String, Date], default: undefined },
        max: { type: [String, Date], default: undefined }
    },
    emits: ['update:modelValue'],
    data() {
        return { menu: false };
    },
    computed: {
        isDisabled() {
            return this.$attrs.disabled === '' || this.$attrs.disabled === true || this.$attrs.readonly === true;
        },
        displayValue() {
            if (!this.modelValue) return '';
            const m = moment(this.modelValue, ['YYYY-MM-DD', moment.ISO_8601, 'DD/MM/YYYY'], true).isValid()
                ? moment(this.modelValue, ['YYYY-MM-DD', moment.ISO_8601, 'DD/MM/YYYY'])
                : moment(this.modelValue);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        },
        pickerDate() {
            if (!this.modelValue) return null;
            const m = moment(this.modelValue);
            return m.isValid() ? m.toDate() : null;
        }
    },
    methods: {
        onPick(val) {
            if (val) {
                // Vuetify VDatePicker emits a Date; normalise to local YYYY-MM-DD
                this.$emit('update:modelValue', moment(val).format('YYYY-MM-DD'));
                this.menu = false;
            }
        },
        clearDate() {
            this.$emit('update:modelValue', null);
        }
    }
};
</script>
